import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

export const IngredientsContainer = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: 1px solid ${COLORS.NEUTRAL_STROKE};

  & > p:first-child {
    margin: 0 0 24px;
    padding: 0 0 16px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    border-bottom: solid 1px ${COLORS.NEUTRAL_STROKE};
  }
`;

export const IngredientsInnerContainer = styled.dl`
  margin: 0;
  padding: 0;
  display: grid;
  column-gap: 16px;
  grid-template-columns: auto 1fr;
  ${media.M` grid-template-columns: repeat(2, auto 1fr); `}

  font-size: 14px;
  line-height: 20px;

  dt {
    margin: 0;
    padding: 0;
    font-weight: 600;
  }

  dd {
    margin: 0;
    padding: 0;
    font-weight: 400;
  }
`;
